<template>
  <div>
    <!-- banner -->
    <div class="row bannerWrap">
      <div class="col-xs-12 col-md-12 noPadding">
        <div class="page-swiper">
          <div class="swiper-container news-swiper-container" v-if="imgList.length">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in imgList" :key="index">
                <div class="banner">
                  <img :src="globalVar.imgUrl+item" width="100%" height="100%" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination newsPagination" v-if="imgList.length > 1"></div>
          </div>
        </div>
        <div class="banner">
          <div class="bannerTip">
            <div class="container">
              <div class="bannerBg">
                <h3>{{banner.title}}</h3>
                <p>{{banner.content}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 入口 -->
    <div class="row serverWrap">
      <div class="container" style="display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;">
        <!-- <div class="col-self-2 noPadding">
          <a
            @click="showAttention"
            :target="globalVar.target"
            class="serverEnter"
          >
            <img src="../../static/images/index/server3.png" alt="参展报名"/>
          </a>
        </div>
        <div class="col-self-2 noPadding">
          
          <a :target="globalVar.target" class="serverEnter" @click="$router.push({path:'MaterialFileData',query:{name:'资料下载',id:306,title:'第21届投洽会大会指南'}})">
            <img src="../../static/images/index/server4.png" alt="参会报名"/>
          </a>
        </div> -->

        <div class="col-self-2 noPadding">
          <!-- <a :href="globalVar.pdfUrl+'/#/ExhibitorBooth?name=网上报名参展'" :target="globalVar.target" class="serverEnter"> -->
          <a href="https://www.xmcrm.org/SelfServiceCenter/login.aspx?exhid=AI6FNH" :target="globalVar.target" class="serverEnter">
            <img src="../../static/images/index/server3 (2).png" alt="参展报名" />
          </a>
        </div>
        <div class="col-self-2 noPadding">
          <!-- globalVar.imgUrl+'/#/Forum' -->
          <!-- <a :href="SelfServicelogin" :target="globalVar.target" class="serverEnter"> -->
          <a href="https://www.xmcrm.org/SelfServiceCenter/login.aspx?exhid=AI6FNH" :target="globalVar.target" class="serverEnter">

            <img src="../../static/images/index/server4 (2).png" alt="参会报名" />
          </a>
        </div>

        <div class="col-self-2 noPadding">
          <!-- globalVar.imgUrl+'/#/Forum' -->
          <a :href="ProjectFilling" :target="globalVar.target" class="serverEnter">
            <img src="../../static/images/index/server5.png" alt="项目填报" />
          </a>
        </div>
        <div class="col-self-2 noPadding">
          <!-- <a :href="SelfServicelogin" :target="globalVar.target" class="serverEnter"> -->
          <a href="https://www.xmcrm.org/SelfServiceCenter/login.aspx?exhid=AI6FNH" :target="globalVar.target" class="serverEnter">

            <img src="../../static/images/index/server2.png" alt="自助服务中心" />
          </a>
        </div>
        <div class="col-self-2 noPadding">
          <a :href="xmcrmLogin" :target="globalVar.target" class="serverEnter">
            <img src="../../static/images/index/server1.png" alt="网上办公室" />
          </a>
        </div>
        <div class="col-self-2 noPadding">
          <a :href="globalVar.cifitWebRoom" :target="globalVar.target" class="serverEnter">
            <img src="../../static/images/index/server6.png" alt="在线洽谈" />
          </a>
        </div>
      </div>
    </div>

    <!-- 广告位 -->
    <!-- <div class="row">
      <div class="container">
        <a class="interbanner" :target="globalVar.target" :href="globalVar.iiforum">
          <img src="../../static/images/index/banner3.jpg" v-if="globalVar.lang=='CN'" />
          <img src="../../static/images/index/banner3_CNTW.jpg" v-else-if="globalVar.lang=='CNTW'" />
        </a>
      </div>
    </div> -->
    <!-- 倒计时 -->
    <div class="row dateBar">
      <!-- 厦洽会 -->
      <div v-if="mdateInfo.type == 0" style="line-height: 30px;font-size: 16px;">
        <p style>第二十一届投洽会</p>距开幕还有
        <span>{{mdateInfo.days}}</span>天
      </div>
      <p v-if="mdateInfo.type==1" style="line-height: 30px;color: #fff900;">{{mdateInfo.year}}投洽会今天隆重开幕！</p>
      <p v-if="mdateInfo.type==2" style="line-height: 30px;color: #fff900;">
        今天是{{mdateInfo.year}}投洽会开幕的第
        <span>{{mdateInfo.days}}</span>天！
      </p>
      <!-- <p v-if="mdateInfo.type==3" style="line-height: 30px;color: #fff900;">热烈祝贺{{mdateInfo.year}}厦洽会暨丝路投资大会成功闭幕！</p> -->
      <!-- 投洽会 -->
      <div v-if="mdateInfo.type == 10" style="line-height: 30px;font-size: 16px;">
        距第{{mdateInfo.year}}届投洽会开幕还有
        <span>{{mdateInfo.days}}</span>天
      </div>
      <p v-if="mdateInfo.type==11" style="line-height: 30px;color: #fff900;">第{{mdateInfo.year}}届投洽会今天隆重开幕！</p>
      <p v-if="mdateInfo.type==12" style="line-height: 30px;color: #fff900;">
        今天是第{{mdateInfo.year}}届投洽会开幕的第
        <span>{{mdateInfo.days}}</span>天！
      </p>
      <p v-if="mdateInfo.type==13" style="line-height: 30px;color: #fff900;">热烈祝贺第{{mdateInfo.year}}届投洽会成功闭幕！</p>
    </div>
    <!-- 最新动态 -->
    <div class="row newsWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-8 col-md-8">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon1.png" />
            <span>最新动态</span>
            <router-link class="more right" :to="{ name: 'LatestPage', query: { name: '最新动态' }}">更多</router-link>
          </div>
          <div class="page-new-main">
            <div class="page-main">
              <div class="page-swiper">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in slideList" :key="index" @click="newsDetailHandle(item.id, 'LatestPageDetail', '最新动态')">
                      <div class="col-xs-12 col-sm-8 col-md-8 noPadding">
                        <img :src="globalVar.imgUrl+item.imgurl" alt />
                      </div>
                      <div class="col-xs-12 col-sm-4 col-md-4 noPadding">
                        <div class="title">
                          <v-clamp autoresize :max-lines="3">{{item.title}}</v-clamp>
                        </div>
                        <p class="summary">
                          <v-clamp autoresize :max-lines="4">{{item.content.trim()}}</v-clamp>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="swiper-pagination newsPagination"></div> -->
                </div>
              </div>
              <div class="row page-news-list">
                <div class="col-xs-12 col-sm-6 col-md-6 noPadding" v-for="(item,nIdx) in newsList.filter((cate,index)=>index<4)" :key="nIdx" @click="newsDetailHandle(item.id, 'LatestPageDetail', '最新动态')">
                  <h4>
                    <v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="2">{{item.content}}</v-clamp>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 featuresWrap">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon2.png" />
            <span>投洽会功能</span>
            <router-link class="more right" :to="{ name: 'FuncPage', query: { name: '功能' }}">更多</router-link>
          </div>
          <div class="page-features-wrap">
            <div class="page-features" @click="FuncPageHandle">
              <div class="row page-features-list">
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding" style="padding-right: 10px;">
                  <img src="../../static/images/aboutcifi/g_1.jpg" />
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding">
                  <h4>
                    <v-clamp autoresize :max-lines="2">国际资本进入中国的“窗口”</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="3">投洽会期间举办的“国际投资论坛”是中国最权威的利用外资政策与国际投资战略论坛，每届均有中国国家领导、国外政界要员、国际经济组织负责人、经济学家、大型跨国公司负责人莅会演讲。另外还有数十场投资热点、投资政策与理论研讨会，数十个国家的政府官员、中介机构负责人、专家学者和企业家到会演讲。投洽会已成为世界各国（地区）投资政策、理论研讨和信息发布的大讲坛，是国际投资的“风向标”。</v-clamp>
                  </p>
                </div>
              </div>
              <div class="row page-features-list">
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding" style="padding-right: 10px;">
                  <img src="../../static/images/aboutcifi/g_2.jpg" />
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding">
                  <h4>
                    <v-clamp autoresize :max-lines="2">中国企业和产品走向世界的“桥梁”</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="3">每届投洽会都吸引超过60多个国家和地区的政府机构参展，举办投资说明会和推介会，介绍当地投资环境和投资项目。英国、法国、加拿大、瑞典、波兰、意大利、比利时、丹麦、香港、澳门等国家和地区都曾举办内容丰富的“馆日”活动。有实力“走出去”投资的中国企业可以通过投洽会了解各国(地区)投资环境和投资信息，大大降低了在全球范围内寻找投资项目的成本。投洽会为中国企业走向世界，寻求境外合作伙伴架设金桥。</v-clamp>
                  </p>
                </div>
              </div>
              <div class="row page-features-list">
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding" style="padding-right: 10px;">
                  <img src="../../static/images/aboutcifi/g_3.jpg" />
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding">
                  <h4>
                    <v-clamp autoresize :max-lines="2">全球投资政策、投资理论研讨和信息发布的“讲坛”</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="3">投洽会期间举办的“国际投资论坛”是中国最权威的利用外资政策与国际投资战略论坛，每届均有中国国家领导、国外政界要员、国际经济组织负责人、经济学家、大型跨国公司负责人莅会演讲。另外还有数十场投资热点、投资政策与理论研讨会，数十个国家的政府官员、中介机构负责人、专家学者和企业家到会演讲。投洽会已成为世界各国（地区）投资政策、理论研讨和信息发布的大讲坛，是国际投资的“风向标”。</v-clamp>
                  </p>
                </div>
              </div>
              <div class="row page-features-list">
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding" style="padding-right: 10px;">
                  <img src="../../static/images/aboutcifi/g_4.jpg" />
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding">
                  <h4>
                    <v-clamp autoresize :max-lines="2">高级公关宣传的“舞台”</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="3">投洽会期间，中国国家领导人，国家有关部门负责人，中国各省、自治区、直辖市由主要领导率领的庞大经贸代表团，以及来自其他国家和地区的数百个政府及经贸代表团和企业界高层齐聚厦门，为参会客商广泛接触各国（地区）政府各级经贸官员、企业高端人士创造良机。此外，境内外数百家新闻媒体的一千多名记者与会，使投洽会成为塑造城市、企业品牌形象和开展媒体公关的首选场所。</v-clamp>
                  </p>
                </div>
              </div>
              <div class="row page-features-list">
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding" style="padding-right: 10px;">
                  <img src="../../static/images/aboutcifi/g_5.jpg" />
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 noPadding">
                  <h4>
                    <v-clamp autoresize :max-lines="2">投资项目的“孵化器”</v-clamp>
                  </h4>
                  <p>
                    <v-clamp autoresize :max-lines="3">每届投洽会期间，组委会都会推出上万个精心筛选的中外投资项目供参会投资商选择。投洽会举办的“外商对华投资项目对接会”、“中国企业‘走出去’投资项目对接会”和“国内投资合作项目对接会”采取会前撮合，大会期间“一对一、面对面”洽谈的方式进行，成为全球投资合作项目的最佳“孵化器”。</v-clamp>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 五个模块 PC-->
    <div class="row serverWrap PcChange " v-if="globalVar.lang =='CN' && 0" style="background-color: #fff;">
      <div class="container">
        <!-- <div id="cloudBox"> -->
        <div class="page-header-news clearfix" style="text-align: left;margin-bottom: 20px;">
          <img class="icon1" src="../../static/images/index/icon6.png" />
          <span style="">云上投洽会</span>
          <router-link class="more right" :to="{ name: 'CloudFairIndex'}">更多</router-link>
        </div>

        <!-- </div> -->
        <div class="felx-wrap">
          <div class="col-self-2 noPadding shadowDiv transDiv" @click="goto('商务部投促局')">
            <!-- <a href="#" onclick="return false"> -->
            <img src="../../static/images/cloudIndex/icon_1.png" alt="商务部投促局" style="" />
            <p class="servername"> 商务部投促局</p>
            <!-- </a> -->
          </div>
          <div class="col-self-2 noPadding shadowDiv transDiv" @click="goto('政府招商')">

            <img src="../../static/images/cloudIndex/icon_2.png" alt="政府招商" style="" />
            <p class="servername"> 政府招商</p>

          </div>
          <div class="col-self-2 noPadding shadowDiv transDiv" @click="goto('投资项目')">

            <img src="../../static/images/cloudIndex/icon_3.png" alt="投资项目" style="" />
            <p class="servername"> 投资项目</p>

          </div>
          <div class="col-self-2 noPadding shadowDiv transDiv" @click="goto('会议')">

            <img src="../../static/images/cloudIndex/icon_4.png" alt="会议" style="" />
            <p class="servername"> 会议</p>

          </div>
          <div class="col-self-2 noPadding shadowDiv transDiv">
            <el-popover placement="top" width="200" trigger="click">
              <div class="flex_col">
                <el-image src="../../../static/images/newapp/wxXcx.jpg" fit="fit"></el-image>
              </div>
              <div class="shadowDiv2" slot="reference">

                <img src="../../static/images/cloudIndex/icon_5.png" alt="要客预约" style="" />
                <p class="servername"> 要客预约</p>

              </div>
            </el-popover>
          </div>
        </div>

      </div>
    </div>
    <!-- 3D展厅 -->
    <div class="row adPicWrap">
      <div class="container">
        <img src="../../static/images/3D/3DBG.png" alt="" srcset="" style="cursor:pointer;max-width:100%" @click="$router.push({name:'3D展厅'})">
      </div>
    </div>

    <!-- 广告图 -->
    <div class="row adPicWrap" v-if="adPicWrap1.length">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6 page-adPic" v-for="(item,idx) in adPicWrap1" :key="idx" v-show="item.state != -1" @click="topic(item)">
          <img v-if="item.state === 1" :src="globalVar.imgUrl+item.imgurl" alt="广告" />
          <img v-if="item.state === 0" :src="globalVar.imgUrl+item.imgurl" alt="广告" />
        </div>
      </div>
    </div>
    <!-- 四大路口 -->
    <div class="row four-enterWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-3 col-md-3 page-four-enter">
          <router-link class="more" :to="{ name: 'ActPage', query: { name: '活动预览表' }}">
            <img src="../../static/images/index/enter4-1.png" alt="活动预览表" />
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-3 col-md-3 page-four-enter">
          <router-link class="more" :to="{ name: 'SeminarPage'}">
            <img src="../../static/images/index/enter4-2.png" alt="论坛研讨会一览表" />
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-3 col-md-3 page-four-enter">
          <router-link class="more" :to="{ name: 'pdfProPage', query: {name: '项目对接会安排'}}">
            <img src="../../static/images/index/enter4-3.png" alt="项目对接会" />
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-3 col-md-3 page-four-enter">
          <router-link class="more" :to="{ name: 'SearchPage', query: { name: '展商信息' }}">
            <img src="../../static/images/index/enter4-4.png" alt="展商信息" />
          </router-link>
        </div>
      </div>
    </div>
    <!-- 展区内容 -->
    <div class="row exhibitionWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon6.png" />
            <span>展区内容</span>
          </div>
          <!-- <div class="page-exhibition">
            <div class="col-xs-12 col-sm-5 col-md-5 page-exhibition-left">
              <div class="col-xs-12 col-sm-12 col-md-12 noPadding page-exhibition-list">
                <div
                  class="col-xs-6 col-sm-6 col-md-6 noPadding"
                  v-for="(eItem,eIdx) in areaObj.list"
                  :key="eIdx"
                >
                  <p @click="picDetal(eItem)">{{eItem.title}}</p>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-7 col-md-7 page-exhibition-right" v-viewer="options">
              <img :src="mainurl" />
            </div>
          </div> -->
          <div class="floor-plan-container module-container">
            <div class="floor-plan module-content">
              <div class="floor-plan-content">
                <el-image :src="mainurl" fit="fill" :preview-src-list="srcList">
                  <div slot="error" style="display: flex;justify-content: center;align-items: center;height: 100%">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="floor-plan-menu">
                  <div class="floor-plan-menu-item" v-for="(item,index) in areaObj.list" :key="index">
                    <div class="item-header" @click="handleSelect(item,index)" :style="item.color==='#00A096'?'cursor: unset':''">
                      <div class="item-left">
                        <div class="item-color" :style="{'background-color':item.color}"></div>
                        <div class="item-name ellipsis-1">{{item.title}}</div>
                      </div>
                      <div class="item-button" style="margin-left: 12px" v-show="item.children.length > 0 && item.color !== '#00A096'">
                        <i class="el-icon-arrow-down" v-show="floorPlanActiveIndex!==index"></i>
                        <i class="el-icon-arrow-up" v-show="floorPlanActiveIndex===index"></i>
                      </div>
                      <div class="item-button" style="margin-left: 12px" v-show="item.children.length === 0 && item.color !== '#00A096'"><i class="el-icon-arrow-right"></i></div>
                    </div>
                    <!-- 隐藏部分 -->
                    <el-collapse-transition>
                      <div class="item-main" v-show="floorPlanActiveIndex===index">
                        <div class="item-main-children ellipsis-1" v-for="item2 in item.children" :key="item2.id" @click="$router.push({ name:'PicDetIPage', query: { id: item.id }})">{{item2.title}}</div>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 广告图 -->
    <div class="row adPicWrap" v-if="adPicWrap2.length">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6 page-adPic" v-for="(item,idx) in adPicWrap2" :key="idx" v-show="item.state != -1" @click="topic(item)">
          <img v-if="item.state === 1" :src="globalVar.imgUrl+item.imgurl" />
          <img v-if="item.state === 0" :src="globalVar.imgUrl+item.imgurl" />
        </div>
      </div>
    </div>
    <!-- 参会服务 -->
    <div class="row serviceWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon7.png" />
            <span>参会服务</span>
          </div>
          <div class="row page-service">
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <!-- 最新一届的id -->
              <router-link :to="{ name: 'BackHisPage', query: { name: '历史回望' }}" class="serverEnter">
                <img src="../../static/images/index/icon-service-1.png" alt="上届回顾" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{ name: 'TicketPage', query: { name: '票证办理程序' }}" class="serverEnter">
                <img src="../../static/images/index/icon-service-2.png" alt="票证办理程序" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{ name: 'ReporterPage', query: { name: '记者参会指南' }}" class="serverEnter">
                <img src="../../static/images/index/icon-service-3.png" alt="记者参会指南" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{name: 'TrafficPage', query: {name: '交通服务'}}" class="serverEnter">
                <img src="../../static/images/index/icon-service-4.png" alt="交通服务" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{name: 'Hotel', query: {name: '找酒店'}}" class="serverEnter">
                <img src="../../static/images/index/icon-service-5.png" alt="找酒店" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{ name: 'SponsorPage', query: { name: '历届赞助机构' }}" class="serverEnter">
                <img src="../../static/images/index/icon-service-6.png" alt="历届赞助机构" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{ name: 'volunteerPage', query: { name: '志愿者服务' }}" class="serverEnter">
                <img src="../../static/images/index/icon-service-7.png" alt="志愿者服务" />
              </router-link>
            </div>
            <div class="col-xs-3 col-sm-3 col-md-3 page-service-enter">
              <router-link :to="{name: 'FilePage', query: {name: '资料下载'}}" class="serverEnter">
                <img src="../../static/images/index/icon-service-8.png" alt="资料下载" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频 -->
    <div class="row videoWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-5 col-md-5">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon4.png" />
            <span>投洽会视频</span>
            <router-link class="more right" :to="{ name: 'VideoPage', query: { name: '视频点播' }}">更多</router-link>
          </div>
          <div class="page-video">
            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
          </div>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-7">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/index/icon5.png" />
            <span>精彩图片</span>
            <router-link class="more right" :to="{ name: 'PicPage', query: { name: '图片新闻' }}">更多</router-link>
          </div>
          <div class="page-other-video">
            <div class="col-xs-6 col-sm-4 col-md-4 page-video-list" v-for="(item,pidx) in picList.filter((cate, idx) => idx < 6)" :key="pidx" @click="newsDetailHandle(item.id,'PicPageDetail', '图片新闻')">
              <div class="page-img">
                <img class="imgheight" :src="globalVar.imgUrl+item.imgurl" />
              </div>
              <div class="page-video-title">
                <v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 三大路口 -->
    <div class="row four-enterWrap">
      <div class="container page-three-enter">
        <div class="col-xs-6 col-sm-4 col-md-4 page-four-enter mHide">
          <router-link :to="{ name: 'guestPage', query: { name: '历届嘉宾' }}">
            <img src="../../static/images/index/enter3-1.png" alt="历届嘉宾" />
          </router-link>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-4 page-four-enter">
          <router-link :to="{ name: 'dataIndexPage', query: { name: '数据统计' }}">
            <img src="../../static/images/index/enter3-2.png" alt="数据统计" />
          </router-link>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-4 page-four-enter">
          <a :href="aboutUs">
            <img src="../../static/images/index/enter3-3.png" alt="关于我们" />
          </a>
        </div>
      </div>
    </div>
    <!-- 战略合作伙伴 -->
    <div class="row partnerWrap">
      <div class="container" style="width:1200px;max-width:100%">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="page-header-news clearfix margin">
            <img class="icon1" src="../../static/images/index/icon8.png" />
            <!-- <span>{{partner1.name}}</span> -->
            <span>战略合作伙伴</span>
          </div>
          <div class="flex_sb">
            <a class="page-partner-list" v-for="(item,idx) in partner1.list" :key="idx" :target="globalVar.target" :href="item.url" :style="!item.url?'pointer-events:none':''">
              <img :src="globalVar.imgUrl+item.imgurl" style="width:375px;max-width: 45vw;margin-bottom: 10px;" />
            </a>
          </div>

          <div class="page-partner" v-if="partner2">
            <div class="page-header-news clearfix  margin">
              <img class="icon1" src="../../static/images/index/icon9.png" />
              <span>{{partner2.name}}</span>
            </div>
            <div style="display: flex;
              flex-wrap: wrap;
              align-items: center;">
              <div :class="['flex_sb',idx==15?'justifyContentStart':'']" style="width:100%" v-for="(item,idx) in partner2.list" :key="idx" :a="idx" v-if="idx%5==0">
                <a style="max-width: 45vw;margin-bottom: 10px;width:216px;margin:10px 0px" class="" :target="globalVar.target" :href="partner2.list[idx].url" :style="!partner2.list[idx].url?'pointer-events:none':''">
                  <img :src="globalVar.imgUrl+partner2.list[idx].imgurl" />
                </a>
                <a style="max-width: 45vw;margin-bottom: 10px;width:216px;margin:10px 0px" class="" :target="globalVar.target" :href="partner2.list[(idx+1)].url" :style="!partner2.list[(idx+1)].url?'pointer-events:none':''">
                  <img :src="globalVar.imgUrl+partner2.list[(idx+1)].imgurl" />
                </a>
                <a style="max-width: 45vw;margin-bottom: 10px;width:216px;margin:10px 0px" class="" :target="globalVar.target" :href="partner2.list[(idx+2)].url" :style="!partner2.list[(idx+2)].url?'pointer-events:none':''">
                  <img :src="globalVar.imgUrl+partner2.list[(idx+2)].imgurl" />
                </a>

                <a v-if="(partner2.list[(idx+3)])" style="max-width: 45vw;margin-bottom: 10px;width:216px;margin:10px 0px" class="" :target="globalVar.target" :href="partner2.list[(idx+3)].url" :style="!partner2.list[(idx+3)].url?'pointer-events:none':''">
                  <img :src="globalVar.imgUrl+partner2.list[(idx+3)].imgurl" />
                </a>

                <a v-if="(partner2.list[(idx+4)])" style="max-width: 45vw;margin-bottom: 10px;width:216px;margin:10px 0px" class="" :target="globalVar.target" :href="partner2.list[(idx+4)].url" :style="!partner2.list[(idx+4)].url?'pointer-events:none':''">
                  <img :src="globalVar.imgUrl+partner2.list[(idx+4)].imgurl" />
                </a>
              </div>
              <!-- <a
              style="width:18%;margin:10px 0px"
                class=""
                v-for="(item,idx) in partner2.list"
                :key="idx"
                :target="globalVar.target"
                :href="item.url"
              >
                <img :src="globalVar.imgUrl+item.imgurl" />
              </a> -->
            </div>
          </div>
          <div class="page-partner" v-if="partner3">
            <div class="page-header-news clearfix">
              <!-- {{partner3}} -->
              <img class="icon1" src="../../static/images/index/icon9.png" />
              <span>{{partner3.name}}</span>
            </div>
            <div class="row page-partner-main">
              <a class="col-xs-6 col-sm-2 col-md-2 page-partner-list" v-for="(item,idx) in partner3.list" :key="idx" :target="globalVar.target" :href="item.url" :style="!item.url?'pointer-events:none':''">
                <img :src="globalVar.imgUrl+item.imgurl" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import VClamp from "vue-clamp";

export default {
  components: {
    VClamp
  },
  data () {
    return {
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "https://www.chinafair.org.cn/cifit/flash/第21届中国国际投资贸易洽谈会 30秒20210812092332.mp4" //你的视频地址（必填）
          }
        ],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      options: {
        navbar: false,
        title: false,
        toolbar: false,
        transition: false,
        keyboard: false
      },
      SelfServicelogin: this.globalVar.SelfServicelogin,
      xmcrmLogin: this.globalVar.xmcrmLogin,
      ProjectFilling: this.globalVar.ProjectFilling,
      aboutUs: this.globalVar.aboutUs,
      banner: Object,
      iskeep: false,
      imgList: Array,
      slideList: Array,
      adPicWrap1: Array,
      adPicWrap2: Array,
      areaObj: Object,
      video: Array,
      mainurl: "",
      partner1: {},
      partner2: {},
      partner3: {},
      // this.partner3 = partnerData[2];
      // 展区内容 - 右侧 - 导航栏当前活跃索引
      floorPlanActiveIndex: '',
      // 展区内容
      srcList: [], // 展区内容 - 预览大图
    };
  },
  async created () {
    console.log(this.globalVar)
    this.initIndex();
    !this.newsList.length ? await this.newsCenter(5, 0) : "";
    !this.picList.length ? await this.newsCenter(10, 1) : "";
  },
  async activated () {
    this.bannerList();
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player;
    },
    mdateInfo () {
      return this.$store.state.home.dateInfo;
    },
    newsList () {
      return this.$store.state.news.newest;
    },
    picList () {
      return this.$store.state.news.pic;
    }
  },
  methods: {
    goto (val) {
      console.log(val)
      switch (val) {
        case '商务部投促局':
          this.$router.push('BusinessWorkTrends');
          break;
        case '会议':
          this.$router.push('Meeting');
          break;
        case '要客预约':
          this.$router.push('Appointment');
          break;
        case '政府招商':
          this.$router.push('Government');
          break;
        case '投资项目':
          // this.$router.push('InvestmentProject');
          this.$router.push('HotProject');
          break;
      }
    },
    // show() {
    //     const viewer = this.$el.querySelector('.page-img').$viewer;
    //     viewer.show();
    // },
    newsDetailHandle (id, pathName, name) {
      this.$router.push({
        name: pathName,
        query: {
          name: name,
          id: id
        }
      });
    },
    FuncPageHandle () {
      this.$router.push({
        name: "FuncPage",
        query: {
          name: "功能"
        }
      });
    },
    async topic (item) {
      let params = {
        id: item.id
      };
      let data = await this.$store.dispatch("clicks", params);
      if (data.isguest === 1) {
        this.$router.push({
          path: "/topic",
          query: {
            gid: data.gid
          }
        });
      } else {
        window.location.href = data.url;
      }
    },
    async initIndex () {
      // this.bannerList();
      this.slideList = await this.findimgnews();
      this.adPicWrap1 = await this.findAd("A"); //获取广告信息
      this.adPicWrap2 = await this.findAd("F"); //获取广告信息
      this.areaObj = await this.areaList(); //展区内容
      this.mainurl = this.globalVar.imgUrl + this.areaObj.mainurl;
      let vdata = await this.mainVideo(1); // 1：首页投洽会视频
      this.video = vdata[0];
      this.playerOptions.sources[0].src =
        this.globalVar.imgUrl + this.video.fileurl;
      this.playerOptions.poster = this.globalVar.imgUrl + this.video.coverurl;
      let partnerData = await this.partnersList();
      this.partner1 = partnerData[0];
      this.partner2 = partnerData[1];
      this.partner3 = partnerData[2];
    },
    async bannerList () {
      let params = {
        language: this.globalVar.lang
      };
      this.banner = {};
      this.imgList = [];
      this.banner = await this.$store.dispatch("mianimg", params);
      this.imgList = this.banner.imgList;
      this.swiperInte();
    },
    swiperInte () {
      this.$nextTick(function () {
        let indexSwiper = new Swiper(".news-swiper-container", {
          autoplay: 3000,
          speed: 2000,
          grabCursor: true,
          observer: true,
          observeParents: true,
          loop: true,
          autoplayDisableOnInteraction: false,
          pagination: ".swiper-pagination"
        });
        if (indexSwiper.slides.length <= 3) {
          indexSwiper.lockSwipes();
        }
      });
    },
    showAttention () {
      this.$store.state.showNoticeBox = true
    },
    newsCenter (count, type) {
      let params = {
        count,
        type,
        language: this.globalVar.lang
      };
      return this.$store.dispatch("find", params);
    },
    findimgnews () {
      let params = {
        count: 1,
        position: 1, //1:首页最新动态轮播图
        language: this.globalVar.lang
      };
      return this.$store.dispatch("findimgnews", params);
    },
    findAd (code) {
      let params = {
        code,
        language: this.globalVar.lang
      };
      return this.$store.dispatch("findAd", params);
    },
    picDetal (eItem) {
      // if (eItem.type === "0") {
      //   this.$router.push({
      //     name: "PicDetIPage",
      //     query: {
      //       id: eItem.id
      //     }
      //   });
      // } else if (eItem.type === "1") {
      //   window.location.href = eItem.url;
      // } else if (eItem.type === "2") {
      //   this.$router.push({
      //     name: "ActPage",
      //     query: {
      //       id: eItem.id
      //     }
      //   });
      // }
      this.$router.push({
        name: 'PicDetIPage',
        query: {
          id: eItem
        }
      })
    },
    areaList () {
      let params = {
        language: this.globalVar.lang,
        counts: ""
      };
      return this.$store.dispatch("areaList", params);
    },
    mainVideo (type) {
      let params = {
        counts: "",
        type,
        language: this.globalVar.lang
      };
      return this.$store.dispatch("mainVideo", params);
    },
    partnersList () {
      let params = {
        language: this.globalVar.lang,
        counts: ""
      };
      return this.$store.dispatch("partnersList", params);
    },
    // 展区内容 - 导航栏点击
    handleSelect (item, index) {
      // 茶歇室
      if (item.color === '#00A096') {
        return
      }
      // 其他
      if (item.children.length > 0) {
        this.floorPlanActiveIndex === index ? this.floorPlanActiveIndex = '' : this.floorPlanActiveIndex = index
      } else {
        this.$router.push({ name: 'PicDetIPage', query: { id: item.id } })
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../static/function.less";
.col-self-2 {
  // width: 20%;
  width: 16%;
  float: left;
}
.bannerWrap {
  .banner {
    position: relative;
    .bannerTip {
      position: absolute;
      z-index: 2;
      bottom: 20px;
      width: 100%;
      .bannerBg {
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        padding: 20px;
        h3 {
          font-size: 28px;
        }
        p {
          font-size: 20px;
          line-height: 26px;
          margin-top: 10px;
        }
      }
    }
  }
}
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 0px;
}
.serverWrap {
  background-color: #f7f7f7;
  text-align: center;
  padding: 1% 0px;
  .serverEnter {
    display: inline-block;
    padding: 4%;
    &:hover {
      background: #fff;
      .shadow(4px);
    }
  }
}
.interbanner {
  display: block;
}
.dateBar {
  width: 100%;
  background: url("../../static/images/index/daysbg.png") no-repeat center;
  font-size: 20px;
  font-weight: bold;
  line-height: 60px;
  color: #fff;
  text-align: center;
  span {
    font-size: 26px;
    color: #fff900;
    margin: 0 5px;
    vertical-align: bottom;
  }
}
.newsWrap {
  padding: 2% 0px;
  .page-new-main {
    padding: 10px;
    .page-main {
      border: 1px solid #e2adb3;
      .page-swiper {
        .noPadding {
          padding: 10px 10px 0px 10px;
          &:hover {
            .title {
              .hoverTxtColor();
            }
          }
          .title {
            font-size: 18px;
            color: #303133;
            line-height: 26px;
          }
          .summary {
            font-size: @font14;
            color: @color767676;
            line-height: 24px;
            margin-top: 5px;
          }
        }
      }
    }
    .page-news-list {
      margin-top: 2%;
      padding: 0px 10px;
      .noPadding {
        border-top: 1px solid #e4e4e4;
        padding: 15px 10px;
        cursor: pointer;
        &:hover {
          h4 {
            .hoverTxtColor();
          }
        }
      }
      h4 {
        font-size: 16px;
        color: #303133;
        font-weight: bold;
        height: 50px;
        line-height: 24px;
      }
      p {
        font-size: @font14;
        color: @color767676;
        margin-top: 10px;
      }
    }
  }
  .newsPagination {
    bottom: 0px;
    left: auto;
    right: 10px;
    width: auto;
  }
  .featuresWrap {
    padding: 0;
    padding-left: 30px;
    .page-features-wrap {
      padding-top: 10px;
      .page-features {
        padding: 0px 10px;
        background-color: #f7f7f7;
        .page-features-list {
          border-bottom: 1px solid #e4e4e4;
          padding: 13px 0px;
          cursor: pointer;
          &:last-child {
            border: none;
          }
          &:hover {
            h4 {
              .hoverTxtColor();
            }
          }
          h4 {
            font-size: @font14;
            color: #303133;
            font-weight: bold;
          }
          p {
            font-size: @font12;
            color: @color767676;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
.adPicWrap {
  margin-bottom: 2%;
  .page-adPic {
    padding: 1% 1% 0px 1%;
    cursor: pointer;
  }
}
.four-enterWrap {
  width: 100%;
  margin: 2% 0px;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url("../../static/images/index/adBg.png") no-repeat center;
  background-size: cover;
  .page-four-enter {
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a {
      display: inline-block;
    }
    &:hover {
      img {
        .shadow(4px);
      }
    }
  }
}
.exhibitionWrap {
  // .page-exhibition {
  //   padding: 15px 0px;
  //   .page-exhibition-left {
  //     padding: 0px;
  //     padding-right: 15px;
  //     .page-exhibition-list {
  //       .flexitems(center);
  //       background-color: #f3f3f3;
  //       padding: 15px 0px 15px 15px;
  //       .noPadding {
  //         padding-right: 15px;
  //       }
  //       p {
  //         background-color: #fff;
  //         border-radius: 2px;
  //         padding: 10px 6px;
  //         margin: 6px 0px;
  //         font-size: @font14;
  //         cursor: pointer;
  //         &:hover {
  //           .shadow(4px);
  //         }
  //       }
  //     }
  //   }
  //   .page-exhibition-right {
  //     border: 1px solid #e4e4e4;
  //   }
  // }
  .page-exhibition {
    display: flex;
    padding-top: 20px;
    // height: 580px;
    .page-exhibition-left {
      padding: 20px 28px 0 0;
    }
    .page-exhibition-right {
      padding: 20px;
      flex-grow: 1;
      background-color: #f6f6f6;
      //   background-color: #ccc;
      width: 500px;
      .el-menu {
        overflow-y: auto;
        height: 540px;
        border-right: unset;
        background-color: #f6f6f6;
        // background-color: #ccc;
        .el-submenu {
          margin-bottom: 20px;
          background-color: #fff;
          .submenu-title {
            display: inline-block;
            // width: 350px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-menu-item {
            // width: 100%;
            padding: unset !important;
            border-bottom: 1px solid #e5e5e5;
            margin-left: 50px;
            // height: unset;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-menu-item:last-child {
            border-bottom: unset;
          }
        }
        .el-submenu:last-child {
          margin-bottom: 0;
        }
      }
      .el-menu::-webkit-scrollbar {
        width: 7px;
      }
      .el-menu::-webkit-scrollbar-thumb {
        border-radius: 2em;
        background-color: #d2d2d2;
      }
      .el-menu::-webkit-scrollbar-track {
        background-color: #f6f6f6;
        // background-color: #ccc;
      }
    }
  }
}
.serviceWrap {
  .page-service {
    padding: 20px 0px;
    .page-service-enter {
      text-align: center;
      margin: 10px 0px;
      .serverEnter {
        display: inline-block;
        padding: 10%;
        &:hover {
          .shadow(4px);
        }
      }
    }
  }
}
.page-three-enter {
  width: 1000px;
}
.videoWrap {
  .page-video {
    padding: 10px 1%;
    text-align: center;
    cursor: pointer;
  }
  .page-other-video {
    .flexitems(flex-start);
    .page-video-list {
      padding: 10px;
      cursor: pointer;
      .page-img {
        width: 100%;
        text-align: center;
      }
      .page-video-title {
        font-size: @font14;
        color: #303133;
        line-height: 20px;
        height: 48px;
        padding: 5px 0px;
      }
      &:hover {
        .page-video-title {
          .hoverTxtColor();
        }
      }
    }
  }
}
.partnerWrap {
  margin: 2% auto;
  text-align: center;
  background-color: #f6f6f6;
  .page-header-news {
    border-bottom: none;
  }
  .page-partner-main {
    margin-bottom: 4%;
    justify-content: space-between;
    .page-partner-list {
      margin: 20px 0px;
    }
  }
  .margin {
    margin: 10px 0;
  }
  .justifyContentStart {
    justify-content: start !important;
    & > a {
      margin-right: 23px !important;
    }
  }
}
.shadowDiv {
  height: 140px;
  background: #ffffff;
  box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  width: 220px;
  margin: 0;
  padding: 10px;
  margin-bottom: 10px;
}
.transDiv:hover {
  transform: translateY(-10px);

  .servername {
    color: #e41f2b;
  }
}
.felx-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.servername {
  font-size: 18px;
  margin-top: 10px;
  font-weight: bold;
}
.flex_sb {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
@media (min-width: 320px) and (max-width: 767px) {
  .justifyContentStart {
    display: flex;
    justify-content: space-between !important;
    a {
      margin-right: 0 !important;
    }
  }

  .shadowDiv2 {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
  }
  .felx-wrap {
    flex-wrap: wrap;
  }
  .shadowDiv /deep/ span {
    width: 100%;
    display: block;
  }
  .shadowDiv {
    width: 48%;
    height: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-bottom: 10px;
    & img {
      width: 47px;
    }
    & p {
      font-size: 12px;
    }
    & .servername {
      margin-top: 0;
    }
  }
  .exhibitionWrap {
    .page-exhibition {
      flex-wrap: wrap;
      .page-exhibition-left {
        padding-right: 0px;
        .page-exhibition-list {
          p {
            font-size: @font12;
          }
        }
      }
    }
  }
  .page-three-enter {
    width: 100%;
  }
  .featuresWrap,
  .mHide {
    display: none;
  }
  .adPicWrap .page-adPic {
    padding: 1% 15px;
  }
}

// Web端
// @media screen and (min-width: 768px) {
.floor-plan-container {
  // background-color: #f6f7f9;

  .floor-plan {
    // padding: 60px 0 80px;

    .floor-plan-content {
      display: flex;
      justify-content: space-between;
      // padding: 30px;
      margin-top: 40px;
      background-color: #fff;
      border-radius: 8px;

      .el-image {
        flex-shrink: 0;
        width: 685px;
        max-width: 100%;
        // height: 578px;
        height: unset;
      }

      .floor-plan-menu {
        flex-grow: 1;
        height: 578px;
        
        margin-left: 30px;
        overflow-y: auto;

        .floor-plan-menu-item {
          margin-bottom: 28px;
          background-color: #f6f7f9;

          &:last-child {
            margin-bottom: unset;
          }

          .item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 73px;
            padding: 0 30px;
            line-height: 73px;
            &:hover {
              background-color: #ecf5ff;
            }
            cursor: pointer;

            .item-left {
              display: flex;
              align-items: center;

              .item-color {
                width: 26px;
                height: 26px;
                margin-right: 12px;
              }
              .item-name {
                max-width: 369px;
                font-size: 20px;
                font-weight: 400;
                color: #585858;
                line-height: 73px;
              }
            }
          }
          .item-main {
            .item-main-children {
              max-width: 369px;
              padding: 17px 0;
              margin: 0 60px 0 68px;
              border-bottom: 1px solid #e5e5e5;
              cursor: pointer;
              font-size: 14px;
              font-weight: 400;
              color: #666;
              line-height: 20px;
              &:last-child {
                border-bottom: unset;
              }
              &:hover {
                color: #ea0e1e;
              }
            }
          }
        }
      }
      // 滚动条样式
      .floor-plan-menu::-webkit-scrollbar {
        width: 7px;
      }
      .floor-plan-menu::-webkit-scrollbar-thumb {
        border-radius: 2em;
        background-color: #d2d2d2;
      }
      .floor-plan-menu::-webkit-scrollbar-track {
        background-color: #f6f6f6;
      }
    }
  }
}

.exhibitors-manual-container {
  background-color: #f6f7f9;

  .exhibitors-manual {
    padding-bottom: 80px;

    .exhibitors-manual-item {
      &:hover {
        background: linear-gradient(to right, #ebf5ff, #c5d8fe);
      }
    }
  }
}
// }
</style>




// WEBPACK FOOTER //
// src/view/index.vue